module.exports = __webpack_public_path__ + "img/klma.e4e10c7c.jpg";